<template>
  <div class="mb-4">
    <label v-if="label" :for="id">{{ label }}</label>
    <small v-if="helper" class="form-text form-helper">{{ helper }}</small>

    <div class="row">
      <div
        class="col-sm mb-3 mb-sm-0"
        :class="{
          'flex-grow-0': !grow,
          'disabled': item.value === '',
        }"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="row flex-nowrap">
          <div class="col flex-grow-1 flex-shrink-0">
            <label class="choice-input" :class="{ active: binded === item.value }">
              <span class="label">{{ item.label }}</span>
              <input
                :id="id"
                ref="input"
                v-bind="$attrs"
                :class="{ error: errors.length }"
                type="radio"
                :value="item.value"
                v-model="binded"
                @input="$emit('input', item.value), $emit('selected')"
                :disabled="item.value === ''"
              />
              <span class="checkmark"><i class="fal fa-check"></i></span>
              <div class="background"></div>
            </label>
            <p v-if="item.helper"><small class="inline-block mt-2 form-text form-helper">{{item.helper}}</small></p>
          </div>
          <div v-if="index !== items.length - 1" class="d-none d-sm-block or col flex-grow-0 flex-shrink-0">OR</div>
        </div>
      </div>
    </div>

    <Error v-if="errors.length" :errors="errors" />
  </div>
</template>

<script>
import Error from '@/Shared/Inputs/Error';

export default {
  inheritAttrs: false,

  components: {
    Error,
  },

  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line no-underscore-dangle
        return `text-input-${this._uid}`;
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    grow: {
      type: Boolean,
      default: true,
    },
    value: [String, Boolean],
    label: String,
    helper: String,
    errors: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      binded: this.value,
    };
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    },
  },
};
</script>
